<template>
<div>
  <CCard>
      <br/>
      <h2 class="m-auto">{{$t("addProfile.title")}}</h2>
      <ValidationObserver v-slot="{ handleSubmit }">
      <CCardBody>
          <div class="max-w-400 m-auto">
    <CRow class="jc-center">
      <div class="slider-wrapper-mf">
        <CButton
          :pressed.sync="profile.agtType.value == 1 "
          class
          @click="onAgentTypeChange()"
        >{{ $t("addProfile.dirCustomer") }}</CButton>

        <CButton
          :pressed.sync="profile.agtType.value == 2 "
          class
          @click="onAgentTypeChange()"
        >{{ $t("addProfile.agent") }}</CButton>
      </div>
    </CRow>
    <cTextInputComponent
      v-model="profile.agtName"
      :name="profile.agtType.value == 1 ? $t('addProfile.custName') : $t('addProfile.agtName')"
      :label="profile.agtType.value == 1 ? $t('addProfile.custName') : $t('addProfile.agtName')"
      rules="required|Atmax:50|noInitialSpace|onlyAlphabets"
     
    />
    <br />

    <cTextInputComponent
      v-model="profile.address"
      :name="profile.agtType.value == 1 ? $t('addProfile.custAdd') : $t('addProfile.address')"
      :label="profile.agtType.value == 1 ? $t('addProfile.custAdd') : $t('addProfile.address')"
      rules="required|Uptomax:150|noInitialSpace"
     
    />
    <br />
    <cTextInputComponent
      
      v-model="profile.mobile"
      :name="profile.agtType.value == 1 ? $t('addProfile.custMbl') : $t('addProfile.mbl')"
      :label="profile.agtType.value == 1 ? $t('addProfile.custMbl') : $t('addProfile.mbl')"
      rules="required|onlyNumber|Uptomax:15|minimum:4"
     
    />
    <br />
    <cTextInputComponent
      v-model="profile.altMbl"
      :name="profile.agtType.value == 1 ? $t('addProfile.custAlt') : $t('addProfile.altMbl')"
      :label="profile.agtType.value == 1 ? $t('addProfile.custAlt') : $t('addProfile.altMbl')"
      rules="onlyNumber|Uptomax:15|minimum:4"
    />
    <br />
    <cTextInputComponent
      v-model="profile.email"
      :name="profile.agtType.value == 1 ? $t('addProfile.custEmail') : $t('addProfile.email')"
      :label="profile.agtType.value == 1 ? $t('addProfile.custEmail') : $t('addProfile.email')"
      rules="required|email"
     
    />
    <br />
    <cTextInputComponent
      v-model="profile.regNo"
      :name="'agentRegistration'"
      :label="profile.agtType.value == 1 ? $t('addProfile.custId') : $t('addProfile.busRegNo')"
      rules="required|Uptomax:30|no_space|alpha_num"
     
    />
          </div>
    </CCardBody>
    <div class="card-footer d-flex justify-content-between">
          <div class="d-flex justify-content-end">
            <CCol class="pl-0px">
              <CButton color="danger" @click="navToProfileLs()" class="action-c-btn">{{ $t('addProfile.cancelBtn')}}</CButton>
            </CCol>
            <CCol class="pr-0px">
              <CButton
                color="success"
                 @click.prevent="handleSubmit(toCreateProfile)"
                class="action-c-btn"
              >{{ GET_SELECTED_AGENT?$t('addProfile.updateBtn'):$t('addProfile.saveBtn')}}</CButton>
            </CCol>
          </div>
    </div>
    </ValidationObserver>
     <div v-if="alertValue">
                    <CAlert show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>
                   
                  </div>
  </CCard>
   <cAlertModal
                v-if="isShowAlertModal"
                :key="'appProfile'+alertCount"
                :buttonList="modalButton"
                :status="modalStatus"
                :isShowIcon="true"
                :show="isShowAlertModal"
                :desc="confirmTxt"
        ></cAlertModal>
        </div>
</template>
<script>
import { COMPONENT_NAME, PATHNAME, ALERT_MODAL_STATUS } from "../../util/constants";
import { ValidationObserver, ValidationProvider, localize } from "vee-validate";
import Logger from "../../services/logger";
import BaseConfiguration from "../../config/base";
import cTextInputComponent from "../../components/form/cTextInputComponent";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../util/apiValidate.js";
import apiCreateCustomerProfile from "../../services/apiCreateCustomerProfile";
import apiEditCustomerProfile from "../../services/apiEditCustomerProfile";
import Multiselect from "vue-multiselect";
import router, { navigate, goBack, updateDataEdited } from "../../router/index";
import cAlertModal from "../../components/form/cAlertModal";
import {
  cloneData,
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody
} from "../../util/util";
export default {
  name: COMPONENT_NAME.ADD_PROFILE,
  components: {
    cAlertModal,
    ValidationObserver,
    ValidationProvider,
    cTextInputComponent,
    Multiselect,
  },
  data: () => ({
    profile: {
      agtName: null,
      address: null,
      mobile: null,
      altNo: null,
      email: null,
      regNo: null,
      agtType: {
          value : 1
      }
    },
    alertCount:0,
    alertValue: null,
    isShowAlertModal: false,
    modalStatus: ALERT_MODAL_STATUS.INFO,
    modalButton: null,
    confirmTxt: null
  }),

  computed: {
    ...mapGetters("sCreditSaleReport", {
      GET_SELECTED_AGENT: "GET_SELECTED_AGENT",
    }),
  },

  created() {
updateDataEdited(true);
if(this.GET_SELECTED_AGENT){
  this.profile.agtName = this.GET_SELECTED_AGENT.name;
  this.profile.address = this.GET_SELECTED_AGENT.address;
  this.profile.mobile = this.GET_SELECTED_AGENT.mobileNumber;
  this.profile.altNo = this.GET_SELECTED_AGENT.alternativeNumber;
  this.profile.email = this.GET_SELECTED_AGENT.emailid;
  this.profile.regNo = this.GET_SELECTED_AGENT.docid;
  this.profile.agtType.value = this.GET_SELECTED_AGENT.subagentType;
}
  },

  methods: {
      onAgentTypeChange() {
          try {
            if(BaseConfiguration.isDebug) console.log("onAgentTypeChange");
           if(this.profile.agtType.value==1) {
               this.profile.agtType.value=2;
           }else{
               this.profile.agtType.value=1;
           }
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.ADD_PROFILE,
                    "error in onAgentTypeChange",
                    err.toString(),
                    "onAgentTypeChange",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            
     },
     showAlertModal(status, val) {
                this.isShowAlertModal = true;
                this.alertCount += 1;
                this.modalStatus = status;

                if (status == ALERT_MODAL_STATUS.INFO) {
                    this.modalButton = [
                        {
                            name: this.$t('addProfile.cancel'),
                            func: this.toggleShowAlertModal
                        },
                        {
                            name: this.$t('addProfile.yes'),
                            func:  this.GET_SELECTED_AGENT  ? this.editCustomerProfile : this.createCustomerProfile
                        }
                    ];
                } else if (status == ALERT_MODAL_STATUS.SUCCESS || status == ALERT_MODAL_STATUS.FAIL) {
                    this.modalButton = [
                        {
                            name: this.$t('addProfile.ok'),
                            func: this.navToProfileLs
                        }
                    ];
                }
                 
                this.confirmTxt = val;
    },

       toggleShowAlertModal() {
                
                
                this.isShowAlertModal = !this.isShowAlertModal;
                this.modalStatus = ALERT_MODAL_STATUS.INFO;
            },

            navToProfileLs() {
                try {
                  if(BaseConfiguration.isDebug) console.log("navToProfileLs");
                  navigate(PATHNAME.PROFILE_LIST);
                  
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.ADD_PROFILE,
                          "error in navToProfileLs",
                          err.toString(),
                          "navToProfileLs",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  
                }, 

     async createCustomerProfile() {
      let retValue;
      try {
          
        updateDataEdited(false);
        let createCustomerProfileReq;
        
          createCustomerProfileReq = apiCreateCustomerProfile.buildRequest(
            this.profile
          );
       
        if (createCustomerProfileReq) {
          let createCustomerProfileRes = await apiCreateCustomerProfile.getResponse(
            createCustomerProfileReq
          );

          if (VALIDATE_SUCCESS_RES(createCustomerProfileRes)) {
            retValue = createCustomerProfileRes.data.data;
            this.showAlertModal(
                                ALERT_MODAL_STATUS.SUCCESS,
                                this.$t('addProfile.addSuccess'),
                        
                            );
                            
            this.alertValue=null;
          } else {
            let error = getErrorMessage(createCustomerProfileRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
            }
             this.showAlertModal(
                                ALERT_MODAL_STATUS.FAIL,
                                this.alertValue
                            );
          }
        } 
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.ADD_PROFILE,
          "error in getting response from createCustomerProfile API",
          err.toString(),
          "createCustomerProfile",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    }, 

     async editCustomerProfile() {
      let retValue;
      try {
          
        updateDataEdited(false);
        let editCustomerProfileReq;
        if(this.GET_SELECTED_AGENT){
          editCustomerProfileReq = apiEditCustomerProfile.buildRequest(
            this.profile,this.GET_SELECTED_AGENT
          );
        }
        if (editCustomerProfileReq) {
          let editCustomerProfileRes = await apiEditCustomerProfile.getResponse(
            editCustomerProfileReq
          );

          if (VALIDATE_SUCCESS_RES(editCustomerProfileRes)) {
            retValue = editCustomerProfileRes.data.data;
            this.showAlertModal(
                                ALERT_MODAL_STATUS.SUCCESS,
                                this.$t('addProfile.editSuccess'),
                        
                            );
                            
            this.alertValue=null;
          } else {
            let error = getErrorMessage(editCustomerProfileRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
            }
             this.showAlertModal(
                                ALERT_MODAL_STATUS.FAIL,
                                this.alertValue
                            );
          }
        } 
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.ADD_PROFILE,
          "error in getting response from editCustomerProfile API",
          err.toString(),
          "editCustomerProfile",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    }, 
    
     toCreateProfile() {
                try {
                    if (BaseConfiguration.isDebug) console.log("toCreateProfile");
                    if(this.GET_SELECTED_AGENT){
                      this.showAlertModal(
                        ALERT_MODAL_STATUS.INFO,
                        this.$t('addProfile.updateProfileConfirm'),
                        
                    );
                    }else{
                    this.showAlertModal(
                        ALERT_MODAL_STATUS.INFO,
                        this.$t('addProfile.addConfirm'),
                        
                    );
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.ADD_PROFILE,
                        "error in toCreateProfile",
                        err.toString(),
                        "toCreateProfile",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },
  },
  beforeCreate() {
            addClassToBody(COMPONENT_NAME.ADD_PROFILE);
        },

        beforeDestroy() {
            removeClassBody();
            
        },
};
</script>